import React, { useRef, useEffect } from 'react';
import { useAppStore } from "../../../GlobalStore/GlobalStore.ts";

interface AppsNotificationProps {}

const AppsNotification: React.FC<AppsNotificationProps> = ({ }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                setDynamicStateObj({visiblePopup: null});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-neutral-100/75 dark:bg-neutral-900/75 flex items-center justify-center p-4 z-50">
            <div
                ref={modalRef}
                className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl relative border border-neutral-400/20 dark:border-white/10 flex flex-col"
                style={{ width: '600px', height: '300px' }}
            >
                <button
                    onClick={() => setDynamicStateObj({visiblePopup: null})}
                    className="absolute top-6 right-6 dark:text-neutral-200 dark:hover:text-white transition-colors duration-200 hover:opacity-70"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className="flex-1 flex flex-col items-center justify-center px-8">
                    <h2 className="text-2xl font-bold mb-8 dark:text-white mt-8">Enjoying the Onuro Website?</h2>
                    <a
                        href="https://www.onuro.ai/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-cyan-600 hover:bg-cyan-700 dark:bg-cyan-700 dark:hover:bg-cyan-600 text-white px-8 py-3 rounded-xl font-medium transition-all duration-200 hover:shadow-lg"
                    >
                        Check out the other Onuro applications
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AppsNotification;